import { render, staticRenderFns } from "./customerQuotationView.vue?vue&type=template&id=1c2dab4f&scoped=true"
import script from "./customerQuotationView.vue?vue&type=script&lang=js"
export * from "./customerQuotationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2dab4f",
  null
  
)

export default component.exports